import React from "react";
import "./Footer.css";
import { FaInstagram, FaLinkedin, FaEnvelope } from "react-icons/fa";
// Footer component with social media links and styling
export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-orb"></div>

      <h3>Aradhana</h3>
      <p>Crafting dreamy worlds & cosmic stories ✧</p>

      <div className="social-icons">
        <a href="https://www.instagram.com/aradhana_0014/" target="_blank" rel="noreferrer">
          <FaInstagram />
        </a>

        <a href="https://www.linkedin.com/in/aradhanadevi-jadeja" target="_blank" rel="noreferrer">
          <FaLinkedin />
        </a>

        <a href="mailto:aradhanajadeja81@gmail.com">
          <FaEnvelope />
        </a>
      </div>

      <div className="footer-bottom">
        © {new Date().getFullYear()} Aradhana • All dreamy vibes reserved ✦
      </div>
    </footer>
  );
}
